<template>
    <el-container class="f-cont h-full">

        <!-- Aside -->
        <el-aside width="auto" class="bg-white h-full">
            <!-- Menu -->
            <el-menu default-active="1" class="el-menu-vertical border-0 bg-primary h-full relative"
                     :collapse="isCollapse">
                <!-- Logo -->
                <router-link :to="{ path: '/home'}">
                    <el-menu-item index="0" class="mb-16 menu-main-item">
                        <i class="el-icon-menu" v-if="isCollapse"></i>
                        <span slot="title" class="text-white">Orca</span>
                    </el-menu-item>
                </router-link>

                <!-- Navigation -->
                <router-link :to="{ path: 'news'}"  v-if="this.$store.getters.isRepresentative || this.$store.getters.isAdmin">
                    <el-menu-item index="1" class="menu-main-item mt-16">
                        <i class="el-icon-news"></i>
                        <span slot="title" class="text-white">Nieuwsberichten</span>
                    </el-menu-item>
                </router-link>

                <router-link :to="{ path: 'agenda'}" v-if="this.$store.getters.isRepresentative || this.$store.getters.isAdmin">
                    <el-menu-item index="2" class="menu-main-item">
                        <i class="el-icon-date"></i>
                        <span slot="title" class="text-white">Agenda</span>
                    </el-menu-item>
                </router-link>


                <router-link :to="{ path: 'users'}" v-if="this.$store.getters.isAdmin">
                    <el-menu-item index="3" class="menu-main-item">
                        <i class="el-icon-user"></i>
                        <span slot="title" class="text-white">Gebruikers</span>
                    </el-menu-item>
                </router-link>

                <router-link :to="{ path: 'enrollments'}">
                    <el-menu-item index="4" class="menu-main-item">
                        <i class="el-icon-receiving"></i>
                        <span slot="title" class="text-white">Inschrijvingen</span>
                    </el-menu-item>
                </router-link>

                <router-link :to="{ path: 'performances'}">
                    <el-menu-item index="5" class="menu-main-item">
                        <i class="el-icon-timer"></i>
                        <span slot="title" class="text-white">Prestaties</span>
                    </el-menu-item>
                </router-link>

                <router-link :to="{ path: 'images'}" v-if="this.$store.getters.isRepresentative || this.$store.getters.isAdmin">
                    <el-menu-item index="6" class="menu-main-item">
                        <i class="el-icon-picture-outline"></i>
                        <span slot="title" class="text-white">Afbeeldingen</span>
                    </el-menu-item>
                </router-link>

                <router-link :to="{ path: 'faq'}" v-if="this.$store.getters.isRepresentative || this.$store.getters.isAdmin">
                    <el-menu-item index="7" class="menu-main-item">
                        <i class="el-icon-chat-dot-square"></i>
                        <span slot="title" class="text-white">FAQ</span>
                    </el-menu-item>
                </router-link>

                <router-link :to="{ path: 'branches'}">
                    <el-menu-item index="8" class="menu-main-item">
                        <i class="el-icon-medal"></i>
                        <span slot="title" class="text-white">Takken</span>
                    </el-menu-item>
                </router-link>

                <router-link :to="{ path: 'sponsors'}" v-if="this.$store.getters.isAdmin">
                    <el-menu-item index="9" class="menu-main-item">
                        <i class="el-icon-wallet"></i>
                        <span slot="title" class="text-white">Sponsors</span>
                    </el-menu-item>
                </router-link>

                <!-- Logo -->
                <div v-if="isCollapse" class="stick-bott">
                    <el-menu-item index="8"
                                  class="menu-main-item bg-gray-200 absolute bottom-0 left-0 right-0 icon-blue"
                                  @click="isCollapse=!isCollapse">
                        <i class="el-icon-right"></i>
                        <span slot="title" class="text-white">Vergroot</span>
                    </el-menu-item>
                </div>
                <div v-else class="stick-bott">
                    <el-menu-item index="1"
                                  class="menu-main-item bg-gray-200 absolute bottom-0 left-0 right-0 icon-blue"
                                  @click="isCollapse=!isCollapse">
                        <i class="el-icon-back"></i>
                        <span slot="title" class="text-primary">Verklein</span>
                    </el-menu-item>
                </div>
            </el-menu>
        </el-aside>

        <!-- Content -->
        <el-container class="h-full bg-blue-lightest">
            <!-- Header -->
            <el-header height="64px">
                <el-row type="flex" align="middle" justify="space-around" class="p-5">

                    <el-col>
                        <el-page-header @back="goBack">
                            <span slot="title">Terug</span>
                            <span slot="content" class="text-base">{{ currentRouteName }}</span>
                        </el-page-header>
                    </el-col>
                    <el-col>
                        <el-link type="primary" :underline="false" class="float-right" @click="logout">Uitloggen</el-link>
                    </el-col>
                </el-row>
            </el-header>

            <!-- Content main -->
            <el-main class="shadow-inner ">
                <router-view/>
            </el-main>
        </el-container>
    </el-container>
</template>

<script>
    export default {
        name: "Dashboard",
        data: function () {
            return {
                isCollapse: true,
                searchInput: ""
            }
        },
        methods: {
            goBack() {
                this.$router.replace({ name: '/home', force: true });
            },
            logout () {
                this.$store.dispatch('logout')
                this.$router.replace({ name: 'Login', force: true });
            },
        },
        computed: {
            currentRouteName() {
                return this.$route.name;
            }
        }
    }
</script>

<style>
    .f-cont, .el-menu-vertical {
      height: 100vh !important;
      position: relative !important;
    }
    .el-menu-vertical {
      background-color: #409EFF !important;
    }
   .menu-main-item i::before {
        color: white;
    }

    .menu-main-item:hover i::before {
        color: #409EFF;
    }

    .icon-blue i::before {
        color: #409EFF;
    }

   .el-menu-item.menu-main-item.is-active {
       background-color: white;
   }

   .el-menu-item.menu-main-item.is-active i::before {
        color: #409EFF !important;
   }

  .stick-bott {
    position: absolute !important;
    left: 0;
    right: 0;
    bottom: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard.vue